import { ConnectProto } from "@racoon/api";

import { enumNumber } from "./job-enums";

const MSW_JOB_TYPES = new Set<number>([
  ConnectProto.JobType.MSW,
  ConnectProto.JobType.MSW_CLEANUP,
  ConnectProto.JobType.MSW_MOBILE_CLEANUP,
]);

// Older jobs may carry no category; their type still tells an MSW job apart.
export const isMswJob = (job: ConnectProto.Job) => {
  const category = enumNumber(ConnectProto.JobCategorySchema, job.jobCategory);
  if (category !== undefined && category !== ConnectProto.JobCategory.UNDEFINED) {
    return category === ConnectProto.JobCategory.MSW;
  }
  const type = enumNumber(ConnectProto.JobTypeSchema, job.type);
  return type !== undefined && MSW_JOB_TYPES.has(type);
};
